import { Pressable } from 'react-native';

import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { EventDetailInfoRow } from '@/features/guardian/components/event-detail/event-detail-info-row';
import type { FamilyEventVenue } from '@/features/guardian/family-events';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

const strings = STRINGS.guardian.kids.eventDetail;

type EventDetailVenueRowProps = {
  venue: FamilyEventVenue;
  onOpenMap?: () => void;
};

export function EventDetailVenueRow({ venue, onOpenMap }: EventDetailVenueRowProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <EventDetailInfoRow icon="IcLocationFill">
      <Stack direction="row" align="flex-start" gap={scale(8)}>
        <Stack flex={1} minWidth={0} gap={scale(4)}>
          <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.name}>
            {venue.name}
          </Text>
          <Text variant="Font Guardian App/Subtitle/Subtitle 12 Regular" style={styles.address}>
            {venue.addressLine}
          </Text>
          {venue.distanceLabel ? (
            <Text variant="Font Guardian App/Subtitle/Subtitle 12 Semibold" style={styles.distance}>
              {venue.distanceLabel}
            </Text>
          ) : null}
        </Stack>
        <Pressable
          accessibilityLabel={strings.viewMap}
          accessibilityRole="button"
          disabled={!onOpenMap}
          hitSlop={scale(8)}
          onPress={onOpenMap}
          style={({ pressed }) => [styles.mapButton, pressed ? styles.pressed : null]}>
          <SvgIcon name="IcMapSearch" size={scale(22)} color={guardianColors['Main/Main']} />
        </Pressable>
      </Stack>
    </EventDetailInfoRow>
  );
}

const useStyles = createStyles(({ scale }) => ({
  name: {
    color: guardianColors['10'],
  },
  address: {
    color: guardianColors['6'],
  },
  distance: {
    color: guardianColors['Main/Main'],
  },
  mapButton: {
    width: scale(32),
    height: scale(32),
    alignItems: 'center',
    justifyContent: 'center',
  },
  pressed: {
    opacity: 0.72,
  },
}));
